module.exports = __webpack_public_path__ + "static/media/aqua-win.a9ef1019.png";